"use client";

import { ActionPanel } from "@/components/common/action-panel";
import { createPath } from "@/service/routing/routing";
import { useContext } from "react";
import { SuperLink as Link } from "@/components/common/super-link";
import { UserContext } from "@/contexts/user-context";
import { Permission } from "@/components/common/permission/permission";
import { WebinarRegisterButton } from "@/components/webinar/webinar-resource/components/webinar-action-block/webinar-register-button";

export const WebinarActionBlock = ({
  action,
  additionalPrivacyPolicy,
  hidePanel = false,
}: {
  action: WebinarActionVM;
  additionalPrivacyPolicy: null | string;
  hidePanel?: boolean;
}) => {
  const { isLoggedIn } = useContext(UserContext);

  const { title, message, url, subtype, buttonName } = action;

  if (!isLoggedIn) {
    return <Permission actions={[{ name: "login", data: {} }]} />;
  }

  return (
    <ActionPanel
      hidePanel={hidePanel}
      title={title}
      button={
        buttonName && !(subtype === "can_see_recording" && !url) ? (
          <WebinarRegisterButton action={action} />
        ) : (
          <></>
        )
      }
      message={message}
      disclaimer={
        <>
          Zapisując się, potwierdzam zapoznanie się z zasadami przetwarzania
          moich danych osobowych znajdujących się w Części X.
          <Link href={createPath("privacy_policy")}>Polityki Prywatności</Link>
          {additionalPrivacyPolicy && (
            <p>
              oraz{" "}
              <span
                dangerouslySetInnerHTML={{ __html: additionalPrivacyPolicy }}
              />
            </p>
          )}
        </>
      }
    />
  );
};
